const mediaItems = [
  {
    id: 1,
    title: '独家揭秘：当红流量明星恋情实锤全记录',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20news%20studio%20set%20with%20warm%20red%20spotlights%2C%20empty%20microphone%20stand%2C%20dark%20background%20with%20subtle%20glow%2C%20professional%20broadcast%20studio%20aesthetic%2C%20no%20people%2C%20cinematic%20lighting&width=800&height=500&seq=media-1&orientation=landscape',
    duration: '15:28',
    views: '128万',
    tag: '独家',
  },
  {
    id: 2,
    title: '综艺录制现场突发状况，导演组紧急叫停真相曝光',
    image: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20control%20room%20with%20multiple%20monitors%20displaying%20red%20alert%20signals%2C%20dramatic%20mood%2C%20dark%20atmosphere%20with%20warm%20red%20accents%2C%20professional%20broadcast%20environment%2C%20no%20people&width=800&height=500&seq=media-2&orientation=landscape',
    duration: '08:42',
    views: '96万',
    tag: '现场',
  },
  {
    id: 3,
    title: '半年跟拍：某顶流私生活混乱证据链大汇总',
    image: 'https://readdy.ai/api/search-image?query=A%20detective%20style%20scene%20with%20photos%20and%20documents%20spread%20on%20a%20dark%20wooden%20desk%2C%20red%20string%20connecting%20various%20items%2C%20warm%20dramatic%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20no%20people&width=800&height=500&seq=media-3&orientation=landscape',
    duration: '22:15',
    views: '203万',
    tag: '追踪',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">热门吃瓜视频</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">精选911吃瓜视频合集，带你多角度还原事件真相</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-semibold rounded">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded">{item.duration}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i>2小时前</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}